import { Component, Host, h, Prop } from '@stencil/core';

import store, { ResultDownload, ResultFund } from '../store';

@Component({
  tag: 'ui-download-search-selectable-results',
  styleUrl: 'ui-download-search-selectable-results.scss',
  shadow: true,
})
export class UiDownloadSearchSelectableResults {
  @Prop() downloadMaterialApi: string;

  @Prop() apiKey: string;

  private createSelectableResultItem(result: ResultDownload | ResultFund) {
    return (
      <div key={result.id} class="selectable-results__selectable-result">
        <ui-download-search-result
          downloadMaterialApi={this.downloadMaterialApi}
          apiKey={this.apiKey}
          result={result}
        ></ui-download-search-result>
      </div>
    );
  }

  render() {
    return (
      <Host>
        <div class="selectable-results">
          {store.state.isFetchingResults && (
            <div class="selectable-results__spinner">
              <sd-spinner
                style={{ fontSize: '2rem' }}
                class="selectable-results__spinner__element"
                color="primary"
              ></sd-spinner>
            </div>
          )}
          <div style={store.state.isFetchingResults && { opacity: '25%' }}>
            {store.state.results.length > 0
              ? store.state.results.map((result: ResultDownload | ResultFund) =>
                  this.createSelectableResultItem(result)
                )
              : !store.state.isFetchingResults && (
                  <div class="selectable-results__error-message">
                    <ui-icon
                      icon="exclamation-circle"
                      variant="colored"
                      type="system"
                      class="hydrated"
                    ></ui-icon>
                    <div class="selectable-results__error-message-text">
                      0 Ergebnisse für{' '}
                      <i>&quot; {store.state.searchValue}&quot; </i>. Bitte
                      korrigieren Sie den Suchbegriff bzw. korrigieren Sie den
                      gesetzten Filter.
                    </div>
                  </div>
                )}
          </div>
        </div>
      </Host>
    );
  }
}
